import gql from 'graphql-tag';
import graphqlClient from '@shared/graphql/client';

export class ParentService {
  static async update(id, data, subpropertyId) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation PARENT_UPDATE(
          $id: String!
          $data: ParentInput!
          $subpropertyId: String!
        ) {
          parentUpdate(
            id: $id, 
            data: $data,
            subpropertyId: $subpropertyId
            ) {
            id
          }
        }
      `,

      variables: {
        id,
        data,
        subpropertyId
      },
    });

    return response.data.parentUpdate;
  }

  static async destroyAll(ids, subpropertyId) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation PARENT_DESTROY(
          $ids: [String!]!
          $subpropertyId: String!
          ) {
          parentDestroy(
            ids: $ids,
            subpropertyId: $subpropertyId
          )
        }
      `,

      variables: {
        ids,
        subpropertyId
      },
    });

    return response.data.parentDestroy;
  }

  static async create(data, subpropertyId) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation PARENT_CREATE(
          $data: ParentInput!
          $subpropertyId: ParentInput!
          ) {
          parentCreate(
            data: $data,
            subpropertyId: $subpropertyId
            ) {
            id
          }
        }
      `,

      variables: {
        data,
        subpropertyId
      },
    });

    return response.data.parentCreate;
  }

  static async import(values, importHash, subpropertyId) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation PARENT_IMPORT(
          $data: ParentInput!
          $importHash: String!
          $subpropertyId: String!
        ) {
          parentImport(
            data: $data, 
            importHash: $importHash,
            subpropertyId: $subpropertyId
            )
        }
      `,

      variables: {
        data: values,
        importHash,
        subpropertyId
      },
    });

    return response.data.parentImport;
  }

  static async find(id, subpropertyId) {
    const response = await graphqlClient.query({
      query: gql`
        query PARENT_FIND(
          $id: String!
          $subpropertyId: String!
          ) {
          parentFind(
            id: $id,
            subpropertyId: $subpropertyId
            ) {
            id
            firstName
            lastName
            phoneNumber {
              prefix
              number
            }
            gender
            birthdate {
              day
              month
              year
            }
            createdAt
            updatedAt
          }
        }
      `,

      variables: {
        id,
        subpropertyId,
      },
    });

    return response.data.parentFind;
  }

  static async list(filter, orderBy, limit, offset, subpropertyId) {
    if ( !subpropertyId ) return { rows: [], count: 0};
    const response = await graphqlClient.query({
      query: gql`
        query PARENT_LIST(
          $filter: ParentFilterInput
          $orderBy: ParentOrderByEnum
          $limit: Int
          $offset: Int
          $subpropertyId: String!
        ) {
          parentList(
            filter: $filter,
            orderBy: $orderBy,
            limit: $limit,
            offset: $offset,
            subpropertyId: $subpropertyId
          ) {
            count
            rows {
              id
              firstName
              lastName
              email
              phoneNumber {
                prefix
                number
              }
              gender
              birthdate {
                day
                month
                year
              }
              lastLogin
              updatedAt
              createdAt
            }
          }
        }
      `,

      variables: {
        filter,
        orderBy,
        limit,
        offset,
        subpropertyId,
      },
    });

    return response.data.parentList;
  }

  static async listAutocomplete(query, limit, subpropertyId) {
    const response = await graphqlClient.query({
      query: gql`
        query PARENT_AUTOCOMPLETE(
          $query: String
          $limit: Int
          $subpropertyId: Int
        ) {
          parentAutocomplete(
            query: $query, 
            limit: $limit
            subpropertyId: $subpropertyId
            ) {
            id
            label
          }
        }
      `,

      variables: {
        query,
        limit,
        subpropertyId
      },
    });

    return response.data.parentAutocomplete;
  }
}
